<template>
  <v-dialog
    :content-class="contentClass"
    :max-width="modalWidth"
    :retain-focus="false"
    v-model="isModalOpen"
  >
    <component
      ref="contactModal"
      v-if="contact"
      :is="asyncModalComponent"
      type="contact"
      :typeId="contact.con_id"
      :contact="contact"
      @merged="$emit('merged', $event)"
      @close="isModalOpen = false"
    />
  </v-dialog>
</template>

<script>
import EventBus from '@/factories/eventBus';

import ConversationsEmail from '@/views/conversations/helpers/CreateEmailModal';
import ContactMergeModal from '@/views/contacts/merge/ContactMergeModal.vue';
import ContactPortal from './ContactPortal';

export default {
  name: 'ContactActionDialog',
  data() {
    return {
      contact: null,
      modalType: null,
    };
  },
  computed: {
    isModalOpen: {
      get() {
        return !!this.contact;
      },
      set() {
        this.contact = null;
        this.modalType = null;
      },
    },

    contentClass() {
      if (this.modalType === 'merge') return 'fixed-height-md';
      return 'fixed-height-lg';
    },

    modalWidth() {
      if (this.modalType === 'merge') return 600;
      return 680;
    },

    asyncModalComponent() {
      if (!this.modalType) return null;

      switch (this.modalType) {
        case 'email':
          return ConversationsEmail;
        case 'portal':
          return ContactPortal;
        case 'merge':
          return ContactMergeModal;
        default:
          return null;
      }
    },
  },
  mounted() {
    EventBus.$on('openContactActionDialog', (params) => {
      for (const key in params) {
        this[key] = params[key];
      }
    });
  },
};
</script>
